export const MAX_RLPN_EXPORT_RANGE_DAYS = 90

const toLocalDate = (isoDate: string): Date => {
  const [year, month, day] = isoDate.split('-').map(Number)
  return new Date(year, month - 1, day)
}

const addDays = (date: Date, days: number): Date => {
  const result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

const effectiveEndDate = (endDate: string): Date => {
  if (endDate.trim()) {
    return toLocalDate(endDate.trim())
  }
  const today = new Date()
  return new Date(today.getFullYear(), today.getMonth(), today.getDate())
}

export const exceedsMaxRlpnExportRange = (startDate: string, endDate: string): boolean => {
  const start = toLocalDate(startDate.trim())
  const end = effectiveEndDate(endDate)
  return end > addDays(start, MAX_RLPN_EXPORT_RANGE_DAYS)
}

export const MAX_RLPN_EXPORT_RANGE_ERROR =
  'Please select a date range of 90 days or less.'
